import Header from './Header';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Services from './pages/Services';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import {
  About,
  Gallery,
  Legal,
  MeetTheTeam,
  PrivacyPolicy,
  Refund,
  TermsConditions,
} from './pages';
import ServiceType from './pages/ServiceType';
import Submitted from './pages/Submitted';
import './App.css';
import Footer from './Footer';
import CookieConsentBanner from './CookieConsentBanner';

function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/:id" element={<ServiceType />} />
        <Route path="/legal" element={<Legal />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsConditions />} />
        <Route path="/refund-policy" element={<Refund />} />
        <Route path="/about" element={<About />} />
        <Route path="/team" element={<MeetTheTeam />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/submitted" element={<Submitted />} />
      </Routes>
      <Footer />
      <CookieConsentBanner/>
    </Router>
  );
}

export default App;
